import lod_ from "lodash";

/**
 * A forward action (v2) sends the mail right away, without draft, when its config has "autoSend" set to true
 * @param {object} action the action of the assistantConfig
 * @returns {boolean}
 */
export function isAutoSendForwardAction(action) {
	return (
		action?.version === "2.0" && action?.type === "forward" && action?.config?.autoSend === true
	);
}

/**
 * The auto send forward of a conversation forwards its first message, so it is only offered
 * for a conversation with one incoming message and no answer yet.
 * Only the counters are checked, the conversations of a list (ie mass actions) have no messages loaded
 * @param {object} conversation the conversation, with its meta counters
 * @returns {boolean}
 */
export function hasOneIncomingMessageOnly(conversation) {
	return conversation?.meta?.totalMessageIn === 1 && conversation?.meta?.totalMessageOut === 0;
}

/**
 * Same rule as hasOneIncomingMessageOnly, for the selected conversation which has its messages loaded
 * @param {object} conversation the selected conversation
 * @returns {boolean}
 */
export function isAutoSendConversationEligible(conversation) {
	return hasOneIncomingMessageOnly(conversation) && !lod_.isEmpty(conversation?.messages);
}
